module.exports = __webpack_public_path__ + "img/functions_active.323bbcb9.svg";